// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"7c8ce827","767":"494dd43e","945":"973e88d4"}[chunkId] + ".chunk.js";
};